import React, { useState, useEffect } from "react";
import { styled } from "baseui";
import GroupedInputs from "../../components/grouped-inputs/GroupedInputs";
import { Tag, KIND } from "baseui/tag";
import { Block } from "baseui/block";
import EmptyListNotificationComponent from "../../components/empty-list-notification/EmptyListNotificationComponent";

const StyledContainer = styled(Block, ({ $theme }) => ({
  width: "100%",
  padding: "5px 20px 5px 5px",
  margin: "auto",
}));

export default function ModelerParametersView(props) {
  const [inputValues, setInputValues] = useState(props.inputValues);

  useEffect(() => {
    setInputValues(props.inputValues);
  }, [props.inputValues]);

  return (
    <StyledContainer>
      {props.inputGroups && props.inputGroups.length !== 0 ? (
        props.inputGroups.map((group, index) => (
          <GroupedInputs
            key={index}
            disabled={props.disabled}
            inputs={group.inputItems}
            inputValues={inputValues}
            label={group.label}
            onInputValueChange={(groupName, itemName, itemValue) =>
              props.onInputValueChange(groupName, itemName, itemValue)
            }
          />
        ))
      ) : (
        <EmptyListNotificationComponent
          message={
            "This modeler has no editable parameters. You can still generate and download it, but modifications are not possible"
          }
        />
      )}
    </StyledContainer>
  );
}
